/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectInfoDto } from '../../models/backend-project-info-dto';

export interface ProjectsProjectsInfoRetrieve$Params {
  id: number;
}

export function projectsProjectsInfoRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectsInfoRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectInfoDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsInfoRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectInfoDto>;
    }),
  );
}

projectsProjectsInfoRetrieve.PATH = '/api/projects/projects/{id}/info/';
